'use es6';

export const getProblemLang = action => `reportingActions.${action}.problem`;